/**
 * useSupportStats
 * Números do painel de entrada da Central de Atendimento: conversas, avaliações e time.
 *
 * @version 2025.1.0
 */
import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { supportChatService, type SupportStats } from '../services/supportChatService';

export function useSupportStats(enabled: boolean) {
  const { enqueueSnackbar } = useSnackbar();
  const [stats, setStats] = useState<SupportStats | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await supportChatService.getStats();
      setStats(data);
    } catch {
      enqueueSnackbar('Não foi possível carregar o painel de suporte.', { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  }, [enqueueSnackbar]);

  useEffect(() => {
    if (enabled) void load();
  }, [enabled, load]);

  return { stats, isLoading, reload: load };
}
